<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)"><path d="M5 11h14v2H5v-2Z" /></g>
    <defs>
      <clipPath id="a"><path d="M0 0h24v24H0z" /></clipPath>
    </defs>
  </svg>
</template>
